// extracted by mini-css-extract-plugin
export default {"wrapper":"AnimationsHolder_wrapper_H1c2j","inner":"AnimationsHolder_inner_zuspq"};